import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { adminShop, money } from "../../lib/shopApi";
import { btn } from "./shared";
import { OrderDetail } from "./OrderDetail";

export const ORDER_STATUS = {
  paid: ["Paid", "bg-[#E6EFD9] text-[#4E6B2F]"],
  test_draft: ["Test draft (not printed)", "bg-[#FFF4D6] text-[#6D4C1F]"],
  in_production: ["In production", "bg-[#E3EEF9] text-[#2F5B8A]"],
  action_needed: ["Needs you", "bg-[#FFF4D6] text-[#6D4C1F]"],
  partially_shipped: ["Partly shipped", "bg-[#E3EEF9] text-[#2F5B8A]"],
  shipped: ["Shipped", "bg-[#E6EFD9] text-[#4E6B2F]"],
  fulfillment_error: ["Problem", "bg-[#FBE9E7] text-[#A3302A]"],
  needs_review: ["Held for review", "bg-[#FBE9E7] text-[#A3302A]"],
};

export const ShopOrdersTab = ({ passcode }) => {
  const [orders, setOrders] = useState(null);
  const [openId, setOpenId] = useState(null);
  const load = useCallback(() => adminShop.orders(passcode).then(setOrders).catch(() => toast.error("Couldn't load orders.")), [passcode]);
  useEffect(() => { load(); }, [load]);

  const replace = (o) => setOrders((list) => list.map((x) => (x.id === o.id ? o : x)));

  return (
    <div>
      <button type="button" className={`${btn.ghost} mb-4`} onClick={load} data-testid="admin-shop-orders-refresh">Refresh list</button>
      {orders && !orders.length && <p className="text-sm text-[#6D5A50]" data-testid="admin-shop-no-orders">No paid orders yet.</p>}
      <ul className="space-y-3">
        {(orders || []).map((o) => {
          const [label, cls] = ORDER_STATUS[o.status] || [o.status, "bg-[#EDE7DF] text-[#6D5A50]"];
          return (
            <li key={o.id} className="border border-[#E7DFD5] rounded-md bg-[#FDFBF7]" data-testid={`admin-shop-order-${o.order_number}`}>
              <button type="button" onClick={() => setOpenId(openId === o.id ? null : o.id)} className="w-full flex flex-wrap items-center gap-3 p-4 text-left" data-testid={`admin-shop-order-toggle-${o.order_number}`}>
                <span className="font-display text-lg text-[#4B3A2F]">{o.order_number}</span>
                {!o.livemode && <span className="text-[10px] uppercase tracking-[0.2em] bg-[#FFF4D6] text-[#6D4C1F] px-2 py-0.5 rounded">Test</span>}
                <span className="text-sm text-[#6D5A50] flex-1">{o.address.name} · {new Date(o.created_at).toLocaleDateString()}</span>
                <span className="text-sm text-[#4B3A2F]">{money(o.amount_total)}</span>
                <span className={`px-3 py-1 rounded-full text-[11px] uppercase tracking-[0.15em] ${cls}`} data-testid={`admin-shop-order-status-${o.order_number}`}>{label}</span>
              </button>
              {openId === o.id && <OrderDetail order={o} passcode={passcode} onUpdated={replace} />}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
